import classNames from 'classnames'
import React from 'react'

import { type LogoProps } from '~/utils'

import styles from './DefaultLogo.css'

export const DefaultLogo = ({ expanded = false, name }: LogoProps) => (
  <div className={classNames(styles.root, expanded && styles.expanded)}>
    {name}
  </div>
)
